import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

type TeenSessionIconProps = {
  fillColor?: string
  height?: number | string
  width?: number | string
}

export const TeenSessionIcon: FunctionComponent<TeenSessionIconProps> = ({ fillColor, height = 16, width = 14 }) => {
  const { colors } = useTheme()

  return (
    <Svg width={width} height={height} viewBox='0 0 14 16' fill='none'>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.99988 0C4.13559 0 1.8147 2.20455 1.8147 4.92308C1.8147 7.6416 4.13559 9.84615 6.99988 9.84615C9.86418 9.84615 12.1851 7.6416 12.1851 4.92308C12.1851 2.20455 9.86418 0 6.99988 0ZM6.99988 1.47692C9.00136 1.47692 10.6295 3.02277 10.6295 4.92308C10.6295 6.82338 9.00136 8.36923 6.99988 8.36923C4.9984 8.36923 3.37025 6.82338 3.37025 4.92308C3.37025 3.02277 4.9984 1.47692 6.99988 1.47692Z'
        fill={fillColor || colors.iconDefault}
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.2222 15.9998C12.7929 15.9998 12.4444 15.669 12.4444 15.2614C12.4444 12.4109 10.0022 10.0922 7 10.0922C3.99778 10.0922 1.55556 12.4109 1.55556 15.2614C1.55556 15.669 1.20711 15.9998 0.777778 15.9998C0.348444 15.9998 0 15.669 0 15.2614C0 11.5966 3.14015 8.61523 7 8.61523C10.8599 8.61523 14 11.5966 14 15.2614C14 15.669 13.6516 15.9998 13.2222 15.9998Z'
        fill={fillColor || colors.iconDefault}
      />
    </Svg>
  )
}
